if(!__webpack_require__.federation){
	__webpack_require__.federation = {
		initOptions: {"name":"static","remotes":[{"alias":"master","name":"master","entry":"/master/dist/react-shared.js","shareScope":"default"}],"shareStrategy":"version-first"},
		chunkMatcher: function(chunkId) {return !/^(169|267|431|509|862)$/.test(chunkId)},
		rootOutputDir: "../../",
		initialConsumes: undefined,
		bundlerRuntimeOptions: {}
	};
}